import { render, staticRenderFns } from "./PlaygroundDashboard.vue?vue&type=template&id=3987c4b5"
import script from "./PlaygroundDashboard.js?vue&type=script&lang=js&external"
export * from "./PlaygroundDashboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports